const radioUnselectedUrl = '/images/radio-unselected.svg'
const radioSelectedUrl = '/images/radio-selected.svg'

export { radioUnselectedUrl, radioSelectedUrl }
